import { Routes } from '@angular/router';
import { authGuard } from '@core/auth';
import AdminLayout from '@layout/layout';

export const routes: Routes = [
  // OIDC callback
  {
    path: 'callback',
    loadComponent: () => import('@core/auth/callback'),
  },
  // Admin
  {
    path: '',
    component: AdminLayout,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },

      // Dashboard
      {
        path: 'dashboard',
        loadChildren: () => import('@features/dashboard/routes'),
      },

      // Assistant
      {
        path: 'assistant',
        loadChildren: () => import('@features/assistant/routes'),
      },

      // Finance-invoice-tasks
      {
        path: 'finance-invoice-tasks',
        loadChildren: () => import('@features/finance-invoice-tasks/routes'),
      },

      // Finance-invoices (search)
      {
        path: 'finance-invoices',
        loadChildren: () => import('@features/finance-invoices/routes'),
      },

      // Incidents (tasks)
      {
        path: 'incidents',
        loadChildren: () => import('@features/incidents/routes'),
      },

      // Incident search
      {
        path: 'incident-search',
        loadChildren: () => import('@features/incident-search/routes'),
      },

      // Settings
      {
        path: 'settings',
        loadChildren: () => import('@features/settings/routes'),
      },

      // 404 - Catch all
      /*{
        path: '**',
        redirectTo: 'dashboard',
      },*/
    ],
  },
];
